import type { FC } from 'react';
import { useCallback } from 'react';
import { createUseStyles } from 'react-jss';

type ItemProps = {
  id: number,
  name: string,
  thumbnail: string,
  onChange: (id: number) => void,
};

const Item: FC<ItemProps> = (props) => {
  const {
    id,
    name,
    thumbnail,
    onChange,
  } = props;

  const classes = useStyles();

  const handleChange = useCallback(() => {
    onChange?.(id);
  }, [id, onChange]);

  return (
    <div className={classes.item} onClick={handleChange}>
      <div>
        <div className="thumbnail">
          <div style={{ backgroundImage: `url(${thumbnail})` }}>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAATCAYAAACHrr18AAAAGElEQVRIx+3BAQEAAACCIP+vbkhAAQDcGAj7AAE+Ko1pAAAAAElFTkSuQmCC" alt="size layer" data-type="size layer" />
          </div>
        </div>
        <div className="name"><span>{name}</span></div>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  item: {
    '&': {
      '&': {
        display: 'flex',
        cursor: 'pointer',
        marginBottom: '1rem',
        width: 'calc(50% - 0.6rem)',
      },
      '@media (min-width: 768px)': {
        width: 'calc(33.3% - 0.6rem)',
      },
      '@media (min-width: 1024px)': {
        width: 'calc(25% - 0.6rem)',
      },
    },
    '& > div': {
      '&': {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        border: '1px solid #aaaaaa',
        borderRadius: '0.7rem',
        flex: 1,
      },
      '& div.thumbnail': {
        '&': {
          display: 'flex',
          overflow: 'hidden',
          aspectRatio: '300 / 190',
          justifyContent: 'stretch',
          alignItems: 'stretch',
        },
        '& > div': {
          background: 'no-repeat center',
          backgroundSize: 'cover',
          flex: 1,
          margin: '-0.5rem',
          padding: '0.5rem',
        },
        '& img': {
          width: '100%',
        },
      },
      '& div.name': {
        '&': {
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          fontSize: '1.4rem',
          padding: '1rem 0.5rem',
          color: '#3f3f3f',
          background: '#ffffff',
          boxShadow: '0 0 1px black',
        },
        '@media (max-width: 430px)': {
          fontSize: '1.2rem',
        },
      },
    },
  },
});

export default Item;
